/* eslint-disable linebreak-style */
import React, { useState, useRef } from 'react';
import colors from '../modules/colors';
import StoryQ1 from './Affordability/StoryQ1';
import StoryQ2 from './Affordability/StoryQ2';
import CallToActionButton from './CallToActionButton';
import CallToAction from './Affordability/CallToAction';
import PrintToPDF from './PrintToPDF';
import Resources from './Resources';
import StoryContext from '../contexts/StoryContext';
import {
  Box, Grid, makeStyles, Typography, Hidden,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';
import states from '../modules/states';

function AffordabilityStory() {
  const { stateCode } = useParams();
  const [selectedState, setSelectedState] = useState(null);
  const ref = useRef(null);

  return (
    <StoryContext.Provider value={{
      selectedState,
      setSelectedState,
      primaryColor: colors.green,
      darkColor: colors.darkGreen,
      lightColor: colors.lightGreen,
      secondaryColor: colors.grey,
      contrastColor: colors.taupe,
      messageBackgroundColor: colors.taupe,
      selectionColor: colors.grey,
      hoverColor: colors.purple,
    }}
    >
      <CallToActionButton targetRef={ref} />
      <StoryQ1 />
      <StoryQ2 />
      <div ref={ref} />
      <CallToAction />
      <PrintToPDF />
      <Resources />
    </StoryContext.Provider>
  );
}

export default AffordabilityStory;
